module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_10.6944965b.png";